module.exports = __webpack_public_path__ + "img/1494423359.3b0aa8b6.jpg";